<template>
	<div>
		<!-- Headline -->
		<div v-if="showTitle" slot="headline" class="fs5 lh125 fw7 c1 mb2">
			{{ $t("benefits") }}
		</div>

		<!-- Tree of Benefits -->
		<j-card class="bg5">
			<j-expendable-box v-if="tree.length">
				<div class="fs3 c2 fw7 pl3 pr3" slot="header">
					{{ $t("benefits_summary") }}
				</div>
				<div slot="body" class="p2">
					<div v-for="(item, i) in tree" :key="i">
						<benefit-summary-node :node="item" class="mb2" />
					</div>
				</div>
			</j-expendable-box>

			<!-- If no data -->
			<div v-if="!isLoading && tree.length === 0" class="fs3 ta2 p2">
				{{ $t("errors.no_data") }}
			</div>
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import CrmTree from "@/components/CrmTree"
import JExpendableBox from "@/components/JExpendableBox"
import BenefitSummaryNode from "./BenefitSummaryNode"
import api from "../api/"

export default {
	components: { JCard, CrmTree, JExpendableBox, BenefitSummaryNode },

	props: {
		policyId: {
			type: String,
			required: true
		},
		showTitle: {
			type: Boolean,
			required: false,
			default: true
		}
	},

	data() {
		return {
			isLoading: false,
			tree: []
		}
	},

	methods: {
		async fetchBenefits() {
			this.isLoading = true
			const res = await api.benefitSummary({
				where: { id: this.policyId }
			})
			this.isLoading = false

			const benefitGraphs =
				res.data.policies?.list?.[0]?.acceptedOffer?.benefitSummary
					?.benefitGraphs || []

			this.tree = benefitGraphs
		}
	},

	created() {
		this.fetchBenefits()
	}
}
</script>
